import { BaseDto } from '@/shared/dtos/base-dto';

export class lecturas_codigo_barras extends BaseDto {
    public referencia !: string;
    public dispositivo !: string;
 } 
